export class TelaCadastroBasico {
    private id: string;
    private descricao: string;
}
export class CadastrosBasicos {
    static CAPACIDADE_VEICULO = 'CAPACIDADE_VEICULO';
    static CATEGORIA_ATENDIMENTO = 'CATEGORIA_ATENDIMENTO';
    static CATEGORIA_VEICULO = 'CATEGORIA_VEICULO';
    static CID = 'CID';
    static ESPECIE_VEICULO = 'ESPECIE_VEICULO';
    static ESTACAO_TRABALHO = 'ESTACAO_TRABALHO';
    static EXAME = 'EXAME';
    static GRUPO_VEICULO = 'GRUPO_VEICULO';
    static MODELO_APREENDIDO = 'MODELO_APREENDIDO';
    static MOTIVO_INDISPONIBILIDADE = 'MOTIVO_INDISPONIBILIDADE';
    static PECAS_SERVICO = 'PECAS_SERVICO';
    static POTENCIA_VEICULO = 'POTENCIA_VEICULO';
    static PROTOCOLO_MANCHESTER = 'PROTOCOLO_MANCHESTER';
    static TIPO_ATENDIMENTO = 'TIPO_ATENDIMENTO';
    static TIPO_COMBUSTIVEL = 'TIPO_COMBUSTIVEL';
    static TIPO_MANUTENCAO = 'TIPO_MANUTENCAO';
    static TIPO_VEICULO = 'TIPO_VEICULO';
    static TIPOS_SERVICO = 'TIPOS_SERVICO';
    static MATERIAL = 'MATERIAL';
    static CILINDRO_VEICULO = 'CILINDRO_VEICULO';
    static MOTIVO_CANCELAMENTO = 'MOTIVO_CANCELAMENTO';
    static MARCA_PNEU = 'MARCA_PNEU';
    static MARCA_APREENDIDA = 'MARCA_APREENDIDA';
    static STATUS_VEICULO = 'STATUS_VEICULO';
    static PRODUTOS = 'PRODUTOS';
    static DOCUMENTO_VEICULO = 'DOCUMENTO_VEICULO';
    static STATUS_AVL = 'STATUS_AVL';
    static FORMA_AQUISICAO = 'FORMA_AQUISICAO';
    static OFICINA = 'OFICINA';
    static TIPO_RECURSO = 'TIPO_RECURSO';
    static AGENCIA = 'AGENCIA';
    static EQUIPE_TRABALHO = 'EQUIPE_TRABALHO';
    static CADASTRO_UNIDADE = 'CADASTRO_UNIDADE';
    static CADASTRO_UNIDADE_VEICULOS = 'CADASTRO_UNIDADE_VEICULOS';
    static CONSULTA_DOCUMENTO_FUNCIONARIO = 'CONSULTA_DOCUMENTO_FUNCIONARIO';
    static CONSULTA_DOCUMENTO_VEICULO = 'CONSULTA_DOCUMENTO_VEICULO';
    static PNEU = 'PNEU';
    static ESTOQUE_PNEU = 'ESTOQUE_PNEU';
    static PREFIXO = 'PREFIXO';
    static ESTABELECIMENTO_SAUDE = 'ESTABELECIMENTO_SAUDE';
    static MUNICIPIO = 'MUNICIPIO';
    static BAIRRO = 'BAIRRO';
    static FALTASATESTADOS = 'FALTAS_ATESTADOS';
    static CONSULTA_EQUIPE_TRABALHO = 'CONSULTA_EQUIPE_TRABALHO';
    static CONSULTA_EQUIPE_TRABALHO_TURNO = 'CONSULTA_EQUIPE_TRABALHO_TURNO';
    static GERENCIAMENTOFROTAS = 'GERENCIAMENTO_FROTAS';
    static MANUTENCAO_VIATURA = 'MANUTENCAO_VIATURA';
    static MATERIAL_MANUTENCAO = 'MATERIAL_MANUTENCAO';
    static SERVICO_MANUTENCAO = 'SERVICO_MANUTENCAO';
    static PECA_SERVICO_MANUTENCAO = 'PECA_SERVICO_MANUTENCAO';
    static CONTROLE_ABASTECIMENTO = 'CONTROLE_ABASTECIMENTO';
    static ENTRADA_SAIDA_FROTA = 'ENTRADA_SAIDA_FROTA';
    static CAUTELA_VEICULO = 'CAUTELA_VEICULO';
    static TROCAR_MEDICO = 'TROCAR_MEDICO';
    static JUSTIFICATIVA_CARENCIA = 'JUSTIFICATIVA_CARENCIA';
    static DESPACHO_SUCESSO = 'DESPACHO_SUCESSO';
    static SELECIONAR_MEDICO = 'SELECIONAR_MEDICO';
    static ALERTA_VERMELHO_UNIDADES = 'ALERTA_VERMELHO_UNIDADES';
    static ALERTA_VERMELHO_EMERGENCIAS = 'ALERTA_VERMELHO_EMERGENCIAS';
    static VISUALIZAR_ALERTA_VERMELHO = 'VISUALIZAR_ALERTA_VERMELHO';
    static CONSULTA_TELEFONES = 'CONSULTA_TELEFONES';
    static ATENDIMENTOS_ENCERRADOS = 'ATENDIMENTOS_ENCERRADOS';
    static GRUPOS_PROTOCOLO = 'GRUPOS_PROTOCOLO';
    static EVENTOS_PROTOCOLO = 'EVENTOS_PROTOCOLO';
    static INCIDENTES_GRUPO = 'INCIDENTES_GRUPO';
    static GRUPOS_INCIDENTE = 'GRUPOS_INCIDENTE';
    static EVENTOS_GRUPO = 'EVENTOS_GRUPO';
    static GRUPOS_PROTOCOLO_ATENDIMENTO = 'GRUPOS_PROTOCOLO_ATENDIMENTO';
    static MOTIVO_ENTRADA_SAIDA = 'MOTIVO_ENTRADA_SAIDA';
    static EQUIPAMENTOS_OPCIONAIS = 'EQUIPAMENTOS_OPCIONAIS';
    static TIPO_OCORRENCIA_FUNC = 'TIPO_OCORRENCIA_FUNC';
    static CONSULTA_MOTORISTA_FROTA = 'CONSULTA_MOTORISTA_FROTA';
    static FUNCAO_TIPO_VEICULO = 'FUNCAO_TIPO_VEICULO';
    static CADASTRO_TIPO_TURNO = 'TIPO_TURNO';
    static CADASTRO_IMEI = 'CADASTRO_IMEI';
    static CADASTRO_VEICULO_VISTORIA = 'CADASTRO_VEICULO_VISTORIA';
    static TELA_AGENCIA_FUNCIONARIOS = 'AGENCIA_FUNCIONARIOS';
    static TELA_AGENCIA_SEGMENTOS = 'AGENCIA_SEGMENTOS';
    static CADASTRO_CATEGORIA_RECURSO_MATERIAL = 'CADASTRO_CATEGORIA_RECURSO_MATERIAL';
    static TIPO_RECURSO_MATERIAL = 'TIPO_RECURSO_MATERIAL';
    static CADASTRO_ALERTA_AVISO = 'CADASTRO_ALERTA_AVISO';
    static AVISO_INTENSIDADE_RISCOS = 'AVISO_INTENSIDADE_RISCOS';
    static RISCOS = 'RISCOS';
    static NIVEL_RISCOS = 'NIVEL_RISCOS';
    static CADASTRO_CLASSE = 'CADASTRO_CLASSE';
    static CADASTRO_AREA = 'CADASTRO_GRANDE_AREA';
    static CADASTRO_SUBAREA = 'CADASTRO_SUBAREA';
    static CADASTRO_GRUPO_BACIAS = 'CADASTRO_GRUPO_BACIAS';
    static CADASTRO_TIPO_ESTACOES = 'CADASTRO_TIPO_ESTACOES';
    static CADASTRO_ESTACOES_HIDROMETEOROLOGICAS = 'CADASTRO_ESTACOES';
    static CADASTRO_COMPONENTES_ESTACAO = 'CADASTRO_COMPONENTES_ESTACAO';

    static CADASTRO_TIPO_SENSORES = 'CADASTRO_TIPO_SENSORES';
    static CADASTRO_SENSORES = 'CADASTRO_SENSORES';

    static FOTOS_DOCS_ESTACAO = 'FOTOS_DOCS_ESTACAO';

    static CADASTRO_DOACAO_SOLIDARIA = 'CADASTRO_DOACAO_SOLIDARIA';
    static CADASTRO_TIPO_ARQUIVO = 'CADASTRO_TIPO_ARQUIVO';
    static CADASTRO_ARQUIVO_VISTORIA = 'CADASTRO_ARQUIVO_VISTORIA';
    static CADASTRO_COMPLEMENTO_VISTORIA = 'CADASTRO_COMPLEMENTO_VISTORIA';
    static CADASTRO_COMPLEMENTO_VISTORIA_INFORMACOES = 'CADASTRO_COMPLEMENTO_VISTORIA_INFORMACOES';
    static CADASTRO_VARIAVEIS_PRIMARIAS = 'CADASTRO_VARIAVEIS_PRIMARIAS';
    static CADASTRO_VARIAVEIS_LIMIAR = 'CADASTRO_VARIAVEIS_LIMIAR';
    static CADASTRO_VARIAVEIS_SECUNDARIAS = 'CADASTRO_VARIAVEIS_SECUNDARIAS';

    static CADASTRO_CAPACITACAO = 'CADASTRO_CAPACITACAO'
    static CADASTRO_CAPACITACAO_DOC = 'CADASTRO_CAPACITACAO_DOC'
    static CALENDARIO_CAPACITACAO = 'CALENDARIO_CAPACITACAO'
    static CALENDARIO_CAPACITACAO_APROVADOS = 'CALENDARIO_CAPACITACAO_APROVADOS'
    static CALENDARIO_CAPACITACAO_ENVOLVIDOS = 'CALENDARIO_CAPACITACAO_ENVOLVIDOS'
    static CALENDARIO_CAPACITACAO_ENVOLVIDOS_MODAL = 'CALENDARIO_CAPACITACAO_ENVOLVIDOS_MODAL'

    static CADASTRO_PRODUTO = 'CADASTRO_PRODUTO';
    static GERENCIAMENTO_ESTOQUE = 'GERENCIAMENTO_ESTOQUE';
    static GERENCIAMENTO_ESTOQUE_PRODUTOS = 'GERENCIAMENTO_ESTOQUE_PRODUTOS';

    static INSCRICAO_CAPACITCAO = 'INSCRICAO_CAPACITCAO'
    static GESTAO_INSC_CAPACITCAO = 'GESTAO_INSC_CAPACITCAO'
    static CONF_ENV_CAPACITACAO = 'CONF_ENV_CAPACITACAO'
    static LISTA_PRESENCA_CAPACITCAO = 'LISTA_PRESENCA_CAPACITCAO'

    static CADASTRO_INVENTARIO = 'CADASTRO_INVENTARIO';

    static GERA_CERT_CAPACITACAO = 'GERA_CERT_CAPACITACAO';

    static HISTORICO_ATIVIDADE_D = 'HISTORICO_ATIVIDADE_D'
    static HISTORICO_ATIVIDADE_A = 'HISTORICO_ATIVIDADE_A'

    static RISCOS_ALERTA_AVISOS = 'RISCOS_ALERTA_AVISOS'
}



// WEBPACK FOOTER //
// ./src/app/core/tela-cadastro-basico.enum.ts